import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  SETTING_GET_LIST,
  SETTING_GET_LIST_SUCCESS,
  SETTING_GET_LIST_ERROR,
  SETTING_LOAD_ONE,
  SETTING_ADD_EDIT,
  SETTING_SAVE_ADD_EDIT,
  SETTING_SAVE_ADD_EDIT_SUCCESS,
  SETTING_SAVE_ADD_EDIT_ERROR
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
  },
  addEdit: {
    data: null,
    mode: "add",
    loading: false,
    error: false,
    message: null,
  },
};

const settingReducer = (state = INIT_STATE, action) => {
  switch (action.type) {    
    case SETTING_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          filter: action.payload.filter,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
          title: action.payload.title,
          jobId: action.payload.jobId,
        },
      };

    case SETTING_GET_LIST_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case SETTING_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case SETTING_LOAD_ONE:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          loading: true,
        },
      };

    case SETTING_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          mode: action.payload.mode,
          loading: false,
          error: false,
          message: null,
        },
      };

    case SETTING_SAVE_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };
    case SETTING_SAVE_ADD_EDIT_SUCCESS:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: null,
          loading: false,
          error: false,
        },
      };

    case SETTING_SAVE_ADD_EDIT_ERROR:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          loading: false,
          error: true,
          message: action.payload.toString(),
        },
      };

    default:
      return state;
  }
};

export default settingReducer;
